class siteHeader extends HTMLElement {
  constructor() {
    super();
    this.isStickyHeader = this.querySelector('[data-sticky-header]');
    this.drawerTrigger = this.querySelector('[data-toggle-header-menu]');
    this.drawerLinksTrigger = this.querySelectorAll('[data-menu-link-accordion]');
    this.tagTriggers = this.querySelectorAll('.tab-triggers [data-trigger]');
    this.tagTargets = this.querySelectorAll('.tab-content');
    this.resizeObserver = null;
  }
  
  // Batch all DOM reads together to avoid forced reflows
  updateHeaderHeight() {
    // Use double requestAnimationFrame to ensure layout is complete
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Batch all geometric property reads
        const headerHeight = this.clientHeight;
        const announcementBar = document.body.querySelector('.global-announcement-bar');
        const announcementHeight = announcementBar 
          ? headerHeight + announcementBar.clientHeight 
          : headerHeight;
        
        // Batch all DOM writes after reads
        document.body.style.setProperty('--header-height', `${headerHeight}px`);
        document.body.style.setProperty('--header-drawer-top', `${announcementHeight}px`);
      });
    });
  }
  
  connectedCallback(){
    // Calculate header height after element is connected to DOM
    this.updateHeaderHeight();
    
    // Watch for header size changes (responsive, content changes, etc.)
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateHeaderHeight();
      });
      this.resizeObserver.observe(this);
      
      // Also observe announcement bar if it exists
      const announcementBar = document.body.querySelector('.global-announcement-bar');
      if (announcementBar) {
        this.resizeObserver.observe(announcementBar);
      }
    }
    
    // Update on window resize as fallback
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.updateHeaderHeight(), 100);
    });
    
    this.stickyHeader();
    this.drawerTrigger?.addEventListener('click', this.toggleDrawer.bind(this));
    this.toggleNavLinks();
    this.toggleTabs();
    window.onscroll = function() {
      if (window.scrollY < 100) document.body.classList.remove("sticky-header-active")
      else document.body.classList.add("sticky-header-active");
    };
  }
  
  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
  stickyHeader() {
    if (!this.isStickyHeader) {return false}
    this.closest('header').classList.add('header-sticky');
  }
  toggleDrawer(event) {
    event?.preventDefault();
    document.body.classList.contains('menu-open') ? this.drawerClose() : this.drawerOpen();
  }
  drawerOpen() {
    document.body.classList.add('menu-open');
    document.querySelector('site-overlay').showOverlay();
    // check and close cart drawer
    if(document.body.classList.contains('cart-drawer-open')) document.querySelector('ajax-cart')?.drawerClose();
  }
  drawerClose() {
    document.body.classList.remove('menu-open');
    document.querySelector('site-overlay').hideOverlay();
  }
  toggleNavLinks() {
    this.drawerLinksTrigger?.forEach(links => {
      let triggerEles = links.querySelectorAll('[data-trigger-nav-child]');
      triggerEles.forEach(navTitle => {
        navTitle?.addEventListener('click', (e) => {
          e.preventDefault();
          let parentEle = e.currentTarget.closest('li');
          let targetEle = parentEle.querySelector('.nav-child-wrapper');
          parentEle.classList.toggle('active');
          slideToggle(targetEle,250);
        });
      });
    })
  }
  toggleTabs() {
    this.tagTriggers?.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.tagTriggers.forEach(tagTrigger => tagTrigger.classList.remove('active'));
        e.currentTarget.classList.add('active');
        
        let targetEle = e.currentTarget.dataset.trigger;
        this.tagTargets?.forEach(target => (target.id == targetEle) ? target.classList.add('open') : target.classList.remove('open'));
      })
    });
  }
}
customElements.define('site-header', siteHeader);